module.exports = __webpack_public_path__ + "media/images/access-clubs-6007b4624fa223de324714193dee44a2.svg";